import React, { Component } from 'react';
import { EndorsementsList } from './EndorsementsList';

class EndorsementsManager extends Component {
    render() {
        const { buttonHandlers, pending, published, received  } = this.props;

        const publishedData = {
            title: "Published",
            data: published,
            placeholder: "No published endorsements",
            hideDeleteButton: true,
        }
        const receivedData = {
            title: "Unpublished",
            data: received,
            placeholder: "No unpublished endorsements",
        }

        const pendingData = {
            title: "Pending",
            data: pending,
            placeholder: "No pending endorsements",
        }

        return (
            <div className="endorsement-manager">
                <EndorsementsList data={ publishedData } { ...this.props } />
                <EndorsementsList data={ receivedData } { ...this.props } />
                <EndorsementsList data={ pendingData } { ...this.props } />
	            <button className="theme-button" onClick={ () => buttonHandlers.handleEditing( false ) }>
		            Close Manager Panel
	            </button>
            </div>
        )

    }
}

export default EndorsementsManager;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/endorsements/EndorsementManager.js